import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import './LoadingScreen.scss';

const LoadingScreen = () => {
  return (
    <div className='loading-screen-container'>
      <DotLottieReact
        className='loading-animation'
        src='https://lottie.host/8ee7b0dd-63f3-4099-9794-1be7a771d9b5/7WY1x54Kvq.lottie'
        loop
        autoplay
      />
    </div>
  );
};

export default LoadingScreen;
